<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar2></app-topbar2>
    <div class="layout-main-container" style="margin-left: 0px; padding-left: 20px;">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <div class="layout-mask"></div>
</div>